import React from "react";
import PublicNav from "../components/public/PublicNav";
import PublicFooter from "../components/public/PublicFooter";
import "./PublicPage.css";

export default function AboutPublic() {
  return (
    <div className="public-page">
      <PublicNav />
      <main className="public-page__main">
        <section className="public-hero">
          <div className="public-hero__inner">
            <span className="public-hero__kicker">About Zyft.ai</span>
            <h1 className="public-hero__title">
              The Voice of
              <br />
              <span className="public-hero__accent font-serif">Gifting</span>
            </h1>
            <p className="public-hero__subtitle">
              Zyft started as a voice-powered gifting assistant and is now delivering automated
              emotional touchpoints for teams. Our current MVP focuses on AI-generated birthday
              and festival greetings—personalized copy + imagery, reviewable in a customization panel,
              then sent with one click.
            </p>
          </div>
        </section>

        <section className="public-section public-section--problems">
          <div className="public-section__inner public-two-col">
            <div>
              <h2 className="public-h2">Two problems, one platform</h2>
              <div className="public-cards">
                <div className="public-card">
                  <div className="public-card__kicker">Gifting</div>
                  <h3 className="public-card__title">Finding the “perfect gift” is hard</h3>
                  <p className="public-card__text">
                    It’s confusing, time-consuming, and emotionally draining. Most platforms optimize
                    transactions—not emotions.
                  </p>
                  <p className="public-card__text public-card__muted">
                    Roadmap: voice/text gifting requests with emotion + intent understanding.
                  </p>
                </div>
                <div className="public-card">
                  <div className="public-card__kicker">Employee engagement</div>
                  <h3 className="public-card__title">Meaningful touchpoints are missed</h3>
                  <p className="public-card__text">
                    Remembering birthdays, festivals, and milestones is manual. Creating personalized
                    copy and quality visuals takes real time—and generic mass emails feel cold.
                  </p>
                  <p className="public-card__text public-card__muted">
                    Today: AI Greetings MVP that generates copy + imagery and sends via email.
                  </p>
                </div>
              </div>
            </div>

            <div className="public-callout">
              <div className="public-callout__icon">✨</div>
              <h3 className="public-callout__title">AI Greetings MVP</h3>
              <p className="public-callout__text">
                Add employees, pick an occasion, generate a themed card + personalized message,
                review/customize, and send via Resend or SMTP.
              </p>

              <div className="public-callout__list">
                {[
                  "Employee Management Layer",
                  "Occasion Engine",
                  "AI Content Generator",
                  "Greeting Customization Panel",
                  "Email Delivery Pipeline",
                ].map((item) => (
                  <div key={item} className="public-chip">{item}</div>
                ))}
              </div>
            </div>
          </div>
        </section>

       <section className="public-section public-section--soft">
  <div className="public-section__inner">

    <div className="public-section__header">
      <span className="public-section__kicker">MVP workflow</span>

      <h2 className="public-h2">How Zyft works today</h2>

      <p className="public-p">
        <span className="line1">
          SIMPLE, REPEATABLE AND BRAND-ALIGNED
        </span>
        <br />
        <span className="line2">
          built to deliver personalized greetings at scale.
        </span>
      </p>
    </div>

    <ol className="public-steps">
      {[
        "Add employees with name, email, DOB, department, and interests.",
        "System highlights today’s birthdays and upcoming events.",
        "Select an occasion (Diwali, Christmas, New Year, Eid—or birthdays).",
        "AI generates a themed card image and personalized message.",
        "Review, customize, and regenerate content if needed.",
        "One-click email delivery via Resend or SMTP.",
      ].map((step) => (
        <li key={step} className="public-step">
          <span className="public-step__dot" aria-hidden="true" />
          <span className="public-step__text">{step}</span>
        </li>
      ))}
    </ol>

  </div>
</section>

          <section className="public-section">
  <div className="public-section__inner">

    <div className="public-roadmap">
      <div className="public-roadmap__title">Future vision (planned)</div>

      <div className="public-roadmap__scroll">
        <div className="public-roadmap__track">

{[
[
"Shared Memories",
"Capture and celebrate meaningful moments by creating gifts and greetings that reflect shared experiences, milestones, and personal connections between people.",
"/images/memory.png"
],
[
"Midnight surprises",
"Automatically deliver perfectly timed greetings or gifts right at midnight, ensuring special occasions like birthdays begin with a memorable and delightful surprise.",
"/images/surprise.png"
],
[
"Eco-friendly gifts",
"Promote sustainability by offering thoughtfully curated gifts and digital greetings that minimize waste and support environmentally conscious choices.",
"/images/ecofriendly.png"
],
[
"Emotion-based gift wrapping",
"Enhance every gift with wrapping styles and visuals that match the emotion behind the gesture—joy, gratitude, celebration, or appreciation—making the experience more personal and meaningful.",
"/images/emotion.png"
],
[
"Voice + emotion intent engine",
"An intelligent system that understands voice commands and emotional cues to interpret the user’s intent, helping generate personalized gift suggestions and greetings that match the sender’s feelings.",
"/images/microphone.png"
]
].map(([title, desc, img]) => (

<div key={title} className="public-roadmap__item">

<div className="public-roadmap__title">{title}</div>

<div className="public-roadmap__desc">{desc}</div>

<img src={img} alt={title} className="public-roadmap__img" />

</div>

))}


{/* duplicate for smooth infinite scroll */}
{[
[
"Shared Memories",
"Capture and celebrate meaningful moments by creating gifts and greetings that reflect shared experiences, milestones, and personal connections between people.",
"/images/memory.png"
],
[
"Midnight surprises",
"Automatically deliver perfectly timed greetings or gifts right at midnight, ensuring special occasions like birthdays begin with a memorable and delightful surprise.",
"/images/surprise.png"
],
[
"Eco-friendly gifts",
"Promote sustainability by offering thoughtfully curated gifts and digital greetings that minimize waste and support environmentally conscious choices.",
"/images/ecofriendly.png"
],
[
"Emotion-based gift wrapping",
"Enhance every gift with wrapping styles and visuals that match the emotion behind the gesture—joy, gratitude, celebration, or appreciation—making the experience more personal and meaningful.",
"/images/emotion.png"
],
[
"Voice + emotion intent engine",
"An intelligent system that understands voice commands and emotional cues to interpret the user’s intent, helping generate personalized gift suggestions and greetings that match the sender’s feelings.",
"/images/microphone.png"
]
].map(([title, desc, img]) => (

<div key={title} className={ "public-roadmap__item" }>

<div className="public-roadmap__title">{title}</div>

<div className="public-roadmap__desc">{desc}</div>

<img src={img} alt={title} className="public-roadmap__img" />

</div>

))}

        </div>
      </div>
    </div>

  </div>
</section>

        <section className="public-stats">
          <div className="public-stats__inner">
            {[
              ["AI", "Copy + imagery"],
              ["Resend/SMTP", "Email delivery"],
              ["Branding", "Logo + colors"],
              ["Multi-tenant", "Company isolation"],
            ].map(([value, label]) => (
              <div key={label} className="public-stat">
                <div className="public-stat__value">{value}</div>
                <div className="public-stat__label">{label}</div>
              </div>
            ))}
          </div>
        </section>
      </main>
      <PublicFooter />
    </div>
  );
}
